import * as React from 'react';

import { ReactComponent as DatabaseSvg } from './icons/database-table-icon.svg';

export const DatabaseIcon = ({ className }: React.SVGProps<SVGSVGElement>) => {
  return <DatabaseSvg className={className} />;
};
